import {ALERT_TYPES, showAlert} from 'utils/showAlert';

export const copyNarrative = async (narrative: string) => {
  try {
    await navigator.clipboard.writeText(narrative);
    return true;
  } catch {
    showAlert("Couldn't copy the narrative", ALERT_TYPES.ERROR);
    return false;
  }
};
